<template>
  <button
    :type="type"
    class="button"
    :class="cssClass"
    :disabled="disabled"
    v-bind="filteredAttrs"
    @click="callback($event)"
  >
    <slot />
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  emits: ['click'],
})
class BaseButton extends Vue {
  @Prop({ default: 'button' })
  type!: string

  @Prop({ required: false })
  cssClass!: object

  @Prop()
  disabled!: boolean

  callback(e: any) {
    this.$emit('click', e)
  }

  get filteredAttrs() {
    const { onClick: _onClick, ...attrs } = this.$attrs
    return attrs
  }
}

export default toNative(BaseButton)
</script>
